import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppTasksLogicService } from './logic/app-tasks/app-tasks-logic.service';
import { AppTasksService } from './logic/app-tasks.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: AppTasksService,
      useClass: AppTasksLogicService,
    },
  ],
})
export class AppTasksModule {}
